<template>
  <div>
    <el-table :data="projects">
      <el-table-column prop="userId" label="员工id"> </el-table-column>
      <el-table-column prop="name" label="姓名"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <a @click="handleUserType(scope.row.userId)">
            <span v-if="scope.row.staffStatus == 1">在职</span>
            <span v-else>离职</span>
            <i class="el-icon-edit"></i>
          </a>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="更新在职状态"
      :visible.sync="updateUserTypeDialogVisible"
      width="400px"
    >
      <el-select v-model="staffStatus" class="user-type-select">
        <el-option
          v-for="item in status"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button @click="closeUserTypeDialog">取消</el-button>
        <el-button type="primary" @click="handleUpdateUserType">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
import Detail from '../detail';

export default {
  name: 'staff',
  data() {
    return {
      staffStatus: '',
      userIds: '',
      updateUserTypeDialogVisible: false,
      status: [{ value: '1', label: '在职' }, { value: '-1', label: '离职' }]
    };
  },
  computed: {
    ...mapState('staff', ['totalCount', 'pagination', 'projects']),
    ...mapGetters('staff', ['projectList'])
  },
  components: {
    Pagination,
    Detail
  },
  methods: {
    ...mapMutations('staff', ['setEditingProject']),
    ...mapActions('staff', ['update']),
    handleUserType(id) {
      this.updateUserTypeDialogVisible = true;
      this.userIds = id;
    },
    handleUpdateUserType() {
      this.update({ userId: this.userIds, staffStatus: this.staffStatus }).then(
        () => {
          this.$emit('refresh');
          this.updateUserTypeDialogVisible = false;
        }
      );
    },
    closeUserTypeDialog() {
      this.updateUserTypeDialogVisible = false;
      this.userId = '';
    }
  }
};
</script>

<style lang="less" scoped>
.link-button {
  margin-left: 10px;
}
</style>
